<template>
  <v-card style="overflow: hidden">
    <v-row no-gutters align="stretch">
      <v-col cols="2" class="primary text-center py-2 d-flex flex-column justify-center">
        <div class="white--text" v-text="$t('trainingsession.fields.multitask.title')" />
        <v-simple-checkbox
          v-model="internalValue.active"
          class="mt-1"
          dark
          @input="change"
        />
      </v-col>
      <v-col>
        <v-row no-gutters class="px-5">
          <v-col class="px-5">
            <ag-number-field
              v-model="internalValue.lengthOfChoiceList"
              :rules="internalValue.active ? $options.rules.lengthOfChoiceList : []"
              :disabled="!internalValue.active"
              :label="$t('trainingsession.fields.multitask.lengthOfChoiceList')"
              @input="change"
            />
          </v-col>
          <v-col class="px-5">
            <ag-number-field
              v-model="internalValue.mistakePenality"
              :rules="internalValue.active ? $options.rules.mistakePenality : []"
              :disabled="!internalValue.active"
              :label="$t('trainingsession.fields.multitask.mistakePenality')"
              @input="change"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import AgNumberField from 'src/components/common/AgNumberField'

export default {
  name: 'MultitaskSessionForm',
  components: {
    AgNumberField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    internalValue: null,
  }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.internalValue = Helpers.clone(this.value)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
    },
  },
  rules: {
    lengthOfChoiceList: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
    ],
    mistakePenality: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
    ],
  },
}
</script>
